import React from "react";
import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Route, Switch } from "react-router-dom";
import { useRouteMatch } from "../../Helpers/RouteMatcher";
import { DigitalContentPage } from "./DigitalContent/DigitalContentPage";
import { WebinarsPage } from "./Webinars/WebinarsPage";
import { MDBox } from "../../Component/Common/Components/MDBox";
import { MDTypography } from "../../Component/Common/Components/MDTypography";
import { PublicEventsPage } from "./PublicEvents/PublicEventsPage";


export const AcademyBasePage = () => {

    const routes = [
        "/academy/digitalContent",
        "/academy/webinars",
        "/academy/publicEvents",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;

    return (
        <>
            <MDBox style={{ padding: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                    Academy
                </MDTypography>
            </MDBox>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Digital Content" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Training Webinars" value={routes[1]} to={routes[1]} component={Link} />
                        <Tab label="Public Events" value={routes[2]} to={routes[2]} component={Link} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Switch>
                        <Route path={routes[0]}>
                            <DigitalContentPage />
                        </Route>
                        <Route path={routes[1]}>
                            <WebinarsPage />
                        </Route>
                        <Route path={routes[2]}>
                            <PublicEventsPage />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}